"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tokenClass = _interopRequireDefault(require("./tokenClass"));

var _tokens = _interopRequireDefault(require("./tokens"));

var _loader = _interopRequireDefault(require("./loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//import config from 'configFile';
//import config2 from process.env.PUBLIC_URL+'/config.json';
var _default = {
  /**
   * @description Metodo per la chiamata al web service. Passare l'url e i dati all'interno del parametro data. 
   * @param {object} compoenent 
   * @param {string} url 
   * @param {object} data    
   * @param {boolean} showLoader 
   */
  postData: function postData(component) {
    var _arguments = arguments,
        _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var url, data, showLoader, config, response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : '';
              data = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : {};
              showLoader = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : true;
              _context.prev = 3;

              if (showLoader) {
                _loader.default.showLoadPanel(component);
              }

              _context.next = 7;
              return _this.getConfig();

            case 7:
              config = _context.sent;
              _context.next = 10;
              return _this.generateToken();

            case 10:
              data["token"] = _context.sent;
              _context.next = 13;
              return fetch(config.webService + url, {
                method: 'POST',
                // *GET, POST, PUT, DELETE, etc.
                mode: 'cors',
                // no-cors, *cors, same-origin
                cache: 'no-cache',
                // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin',
                // include, *same-origin, omit*/
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                //headers: { 'Accept': 'application/octet-stream','Content-Type': 'application/octet-stream'},

                /*      
                headers: {
                  'Content-Type': 'application/json'
                  // 'Content-Type': 'application/x-www-form-urlencoded',
                },*/
                redirect: 'follow',
                // manual, *follow, error
                referrerPolicy: 'no-referrer',
                // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url      */
                body: JSON.stringify(data) // body data type must match "Content-Type" header

              });

            case 13:
              response = _context.sent;
              return _context.abrupt("return", response.json());

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](3);
              console.log(_context.t0);

              if (showLoader) {
                _loader.default.hideLoadPanel(component);
              }

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 17]]);
    }))();
  },

  /**
   * @description Metodo per la chiamata al web service. Passare l'url e i dati all'interno del parametro data. 
   * @param {object} compoenent 
   * @param {string} url 
   * @param {object} data 
   * @param {boolean} showLoader 
   */
  postFile: function postFile(component) {
    var _arguments2 = arguments,
        _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var url, data, showLoader, config, response;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              url = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : '';
              data = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : {};
              showLoader = _arguments2.length > 3 && _arguments2[3] !== undefined ? _arguments2[3] : true;
              _context2.next = 5;
              return _this2.getConfig();

            case 5:
              config = _context2.sent;
              _context2.prev = 6;

              if (showLoader) {
                _loader.default.showLoadPanel(component);
              }

              _context2.next = 10;
              return _this2.generateToken();

            case 10:
              data["token"] = _context2.sent;
              _context2.next = 13;
              return fetch(config.webService + url, {
                method: 'POST',
                // *GET, POST, PUT, DELETE, etc.
                mode: 'cors',
                // no-cors, *cors, same-origin
                cache: 'no-cache',
                // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin',
                // include, *same-origin, omit*/
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                //headers: { 'Accept': 'application/json','Content-Type': 'application/octet-stream'},

                /*      
                headers: {
                  'Content-Type': 'application/json'
                  // 'Content-Type': 'application/x-www-form-urlencoded',
                },*/
                redirect: 'follow',
                // manual, *follow, error
                referrerPolicy: 'no-referrer',
                // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url      */
                body: JSON.stringify(data) // body data type must match "Content-Type" header

              });

            case 13:
              response = _context2.sent;
              return _context2.abrupt("return", response.blob());

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](6);
              console.log(_context2.t0);

              if (showLoader) {
                _loader.default.hideLoadPanel(component);
              }

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 17]]);
    }))();
  },

  /**
   * @description Metodo per la generazione del token
   * Se il token è già in sessione utilizza quello per generare un nuovo token con quello già creato, in caso
   * contrario ne genera un altro passando il solo codice APPLICATIVO. Gli altri campi (permessi, odbc, ambito, utente) vengono compilati dal servizio
   */
  generateToken: function generateToken() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var token, tokenKey, generatedToken;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              token = new _tokens.default();
              tokenKey = localStorage.getItem("tokenKey");
              generatedToken = "";

              if (!(tokenKey != null && tokenKey !== "")) {
                _context3.next = 8;
                break;
              }

              generatedToken = token.generateTokenFromEncrypted(tokenKey);
              _context3.next = 15;
              break;

            case 8:
              _context3.t0 = token;
              _context3.t1 = _tokenClass.default;
              _context3.next = 12;
              return _this3.getApplicationCode();

            case 12:
              _context3.t2 = _context3.sent;
              _context3.t3 = new _context3.t1(_context3.t2);
              generatedToken = _context3.t0.generateTokenFromPlain.call(_context3.t0, _context3.t3);

            case 15:
              if (!(generatedToken !== undefined && generatedToken !== "" && generatedToken["data"] !== undefined)) {
                _context3.next = 17;
                break;
              }

              return _context3.abrupt("return", generatedToken["data"]);

            case 17:
              _context3.next = 21;
              break;

            case 19:
              _context3.prev = 19;
              _context3.t4 = _context3["catch"](0);

            case 21:
              return _context3.abrupt("return", "");

            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 19]]);
    }))();
  },
  getConfig: function getConfig() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var path, config;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              path = process.env.PUBLIC_URL + "/config.json";
              _context4.next = 3;
              return fetch(path);

            case 3:
              config = _context4.sent;
              _context4.next = 6;
              return config.json();

            case 6:
              config = _context4.sent;
              return _context4.abrupt("return", config);

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },

  /**
   * @description Ritorna il codice dell'applicativo letto dal file di configurazione
   */
  getApplicationCode: function getApplicationCode() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var config;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this4.getConfig();

            case 2:
              config = _context5.sent;
              return _context5.abrupt("return", config["codiceApplicazione"]);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },

  /**
   * @description Ritorna il codice dell'azienda letto dal file di configurazione
   */
  getAziendaId: function getAziendaId() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var config;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this5.getConfig();

            case 2:
              config = _context6.sent;
              return _context6.abrupt("return", config["aziendaId"]);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },

  /**
  * @description Ritorna il nome del copyright
  */
  getCopyright: function getCopyright() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      var config;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this6.getConfig();

            case 2:
              config = _context7.sent;
              return _context7.abrupt("return", config["copyright"]);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },

  /**
   * @description Ritorna il link della home
   */
  getHomePage: function getHomePage() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      var config;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this7.getConfig();

            case 2:
              config = _context8.sent;
              return _context8.abrupt("return", config["homePage"]);

            case 4:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  },

  /**
  * @description Ritorna il link del copyright
  */
  getCopyrightLink: function getCopyrightLink() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      var config;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this8.getConfig();

            case 2:
              config = _context9.sent;
              return _context9.abrupt("return", config["linkCopyright"]);

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  },

  /**
   * @description Ritorna il setup di debug
   */
  getDebug: function getDebug() {
    var _this9 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
      var config;
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this9.getConfig();

            case 2:
              config = _context10.sent;
              return _context10.abrupt("return", config["debug"]);

            case 4:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }))();
  },

  /**
   * @description Ritorna la ragione sociale dell'azienda
   */
  getSidebar: function getSidebar() {
    var _this10 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
      var config;
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this10.getConfig();

            case 2:
              config = _context11.sent;
              return _context11.abrupt("return", config["sidebar"]);

            case 4:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }))();
  },

  /**
   * @description Ritorna l'informazione se è ssl o meno
   */
  getSSL: function getSSL() {
    var _this11 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
      var config;
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return _this11.getConfig();

            case 2:
              config = _context12.sent;
              return _context12.abrupt("return", config["isSSL"]);

            case 4:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }))();
  },

  /**
   * @description Dati i permessi salvate in sessione controlla se ho il permesso per eseguire una determinata action
   * @param {string} action: azione
   */
  checkPermission: function checkPermission(action) {
    var permessi = localStorage.getItem("permessi");
    return permessi.includes(action);
  },

  /**
   * @description Date le funzionalità salvate in sessione controlla se ho il permesso per eseguire una determinata funzionalita
   * @param {string} functionality: funzionalita
   */
  checkFunctionality: function checkFunctionality(functionality) {
    var funzionalita = localStorage.getItem("funzionalita");
    var funzionalitaObj = JSON.parse(funzionalita);
    return funzionalitaObj.indexOf(functionality) >= 0; //return funzionalitaObj.includes(functionality);
  }
};
exports.default = _default;